
// TODO: Future Consideration: If find need more what Lodash can provide, then just use Lodash

// TODO: Consider removing overlap between FrontEnd and BackEnd -- Currently toCamelCase copy/pasted between
// ... Consider placing in Shared Repo

export {
  toCamelCase,
  toSnakeCase,
  toKebabCase,
  toEnumKey,
  
  fromCamelCaseToCapitalizedSpaced,
  fromKebabCaseToCamelCase
}


// Source: https://stackoverflow.com/a/57927739/7318703
function toCamelCase( text: string ) { // exampleCamelCase
  if( !text ) return "";

    /*const test = text.toLowerCase()
        .replace(/[-_\s.]+(.)?/g, (_, c) => c ? c.toUpperCase() : '');

    return text.substring(0, 1).toLowerCase() + text.substring(1);*/
  return text.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
  });
}

// Source: https://www.w3resource.com/javascript-exercises/fundamental/javascript-fundamental-exercise-120.php
function toSnakeCase( text: string ) { // example_snake_case
  if( !text ) return "";

  return text && text
    ?.match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    ?.map( (m: string) => m.toLowerCase())
    ?.join('_')
    ?.toUpperCase();
}

// Source: https://www.geeksforgeeks.org/how-to-convert-a-string-into-kebab-case-using-javascript/
function toKebabCase( text: string ) { // example-kebab-case
  if( !text ) return "";

  return text
    ?.replace(/([a-z])([A-Z])/g, "$1-$2")
    ?.replace(/[\s_]+/g, '-')
    ?.toLowerCase();
}

function toEnumKey( text: string ) {
  if( !text ) return "";

  return toSnakeCase( text )?.toUpperCase();
}

function fromCamelCaseToCapitalizedSpaced( text: string ) {
  if( !text ) return "";

  // Step 1 & 2: Identify word boundaries and insert spaces
  let strWithSpaces = text.replace(/([a-z])([A-Z])/g, '$1 $2');

  // Step 3: Capitalize the first word
  strWithSpaces = strWithSpaces.charAt(0).toUpperCase() + strWithSpaces.slice(1);

  // Step 4: Trim
  return strWithSpaces.trim();
};


function fromKebabCaseToCamelCase( text: string ) { // example-kebab-case -> exampleCamelCase
  if( !text ) return "";

  return text
    ?.toLowerCase()
    ?.replace(/-([a-z])/g, function(match, group1) {
      return group1.toUpperCase();
    });
}
